
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pamong/pegawai/perencanaan/sepakati",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pamong/pegawai/perencanaan/sepakati/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pamong/pegawai/perencanaan/sepakati"])
      });
    }
  